import { useFormikContext } from 'formik';
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Spinner } from 'reactstrap';

type AddToCartProps = {
  cart?: boolean;
};

const AddToCart: React.FC<AddToCartProps> = ({ cart }) => {
  const [showMessage, setShowMessage] = useState(false);
  const {
    values: { quantities, color },
    setFieldValue,
    isSubmitting,
    dirty,
  } = useFormikContext<{
    quantities: Record<string, number>;
    color?: string;
  }>();

  const totalQuantity = useMemo(
    () =>
      Object.values(quantities).reduce((prev, quantity) => {
        const qty = Number(quantity ?? 0);
        return prev + (isNaN(qty) ? 0 : qty);
      }, 0),
    [quantities]
  );

  useEffect(() => {
    if (!color && isSubmitting) {
      setShowMessage(true);
      return;
    }
    setTimeout(() => setShowMessage(false), 1000);
  }, [isSubmitting, color]);

  return (
    <Button
      type="submit"
      onClick={() => setFieldValue('color', undefined, false)}
      disabled={
        (!color && isSubmitting) ||
        (cart && !dirty) ||
        (!cart && !totalQuantity)
      }
      block
    >
      {!color && isSubmitting && <Spinner size="sm" className="mr-2" />}
      {!isSubmitting &&
        showMessage &&
        (cart ? 'カートを更新しました！' : 'カートに追加しました！')}
      {(isSubmitting || !showMessage) &&
        (cart ? 'カートを更新する' : 'すべてカートに追加する')}
    </Button>
  );
};

export default AddToCart;
